export default [
    {
        path: '/asset/asset-item',
        name: 'asset-item',
        props: true,
        component: () => import('@/views/asset/items/index.vue'),
        meta: {
            pageTitle: 'Asset Items',
            breadcrumb: [
                {
                text: 'Asset Items',
                active: true,
                },
            ],
        },
    },
    {
        path: '/asset/asset-item/add',
        name: 'create-asset-item',
        component: () => import('@/views/asset/items/create.vue'),
        meta: {
            pageTitle: 'Create Asset Items',
            breadcrumb: [
                {
                text: 'Asset Items',
                to: { name: 'asset-item' },
                },
                {
                text: 'Create Asset Items',
                active: true,
                },
            ],
        },
    },
    {
        path: '/asset/asset-item/:id',
        name: 'detail-asset-item',
        props: true,
        component: () => import('@/views/asset/items/detail.vue'),
        meta: {
            pageTitle: 'Detail Asset Items',
            breadcrumb: [
                {
                text: 'Asset Items',
                to: { name: 'asset-item' },
                },
                {
                text: 'Detail Asset Items',
                active: true,
                },
            ],
        },
    },
]